import { HeaderBackButton } from "@react-navigation/elements";
import React, { useState, useEffect, useCallback } from "react";

const BackButton = (props) => {
  const {
    onPress = () => {},
    tintColor = "black",
    backImage = null,
    alwaysEnable = false,
  } = props;
  const [backPressed, setBackPressed] = useState(false);
  useEffect(() => {
    if (backPressed && typeof onPress === "function") {
      onPress();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [backPressed]);
  const _onPress = useCallback(() => {
    setBackPressed(true);
  }, []);
  return (
    <HeaderBackButton
      disabled={alwaysEnable ? !alwaysEnable : backPressed}
      onPress={alwaysEnable ? onPress : _onPress}
      tintColor={tintColor}
      backImage={backImage}
    />
  );
};

export default BackButton;
